/**
 * Due to an intermittent `google.visualization.DataTable is not a constructor` error,
 * (which mainly shows up when using Hot-Reload whilst developing),
 * we check if it is construtable (i.e. loaded) before doing anything
 *
 * https://stackoverflow.com/a/70810697
 */
export const getDataTable = ({ dataTableRows }) => {
    if (!google.visualization.DataTable ||
        typeof google.visualization.DataTable !== 'function' ||
        !google.visualization.DataTable.prototype ||
        !google.visualization.DataTable.prototype.constructor)
        return null;
    const dataTable = new google.visualization.DataTable();
    dataTable.addColumn({ type: 'string', id: 'Window' });
    dataTable.addColumn({ type: 'string', id: 'Items' });
    dataTable.addColumn({ type: 'string', id: 'style', role: 'style' });
    dataTable.addColumn({ type: 'date', id: 'Start' });
    dataTable.addColumn({ type: 'date', id: 'End' });
    dataTable.addRows(dataTableRows);
    return dataTable;
};
